// 12, 12a 12A, 12-13, 12a-13b
export function isDoorNr(value) {
    // make validation optional as we handle required in yup
    if (!value)
        return true;
    return /^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)?$/.test(value);
}
